import { usePageHeader } from "@hooks/use_page_header";
import { PopupConfirm } from "@components/general/popup";
import { Inbox } from "@services/dtos/home.dto";
import { linkPage } from "@utils/router";
import { androidRemoveInbox, androidUnreadInbox } from "@utils/android";
import { Button } from "antd";
import moment from "moment";
import { useState } from "react";
import { LuTrash2 } from "react-icons/lu";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export const InboxDetailPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: Inbox };
  usePageHeader("Detail Pesan", { bottomNavigation: "hidden" });
  const [popup, setPopup] = useState<boolean>(false);

  if (!state) {
    return <Navigate to={linkPage.INBOX_PAGE} replace />;
  }

  const onRemoveInbox = () => {
    androidRemoveInbox(`${state.id}`);
    androidUnreadInbox();
    navigate(-1);
  };

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-p-4 tw-rounded-xl card-body">
          <div className="tw-text-xs tw-text-text-tertiary tw-mb-3">
            {moment(state.createdAt || Date.now()).format(
              "dddd, DD MMMM YYYY | HH:mm",
            )}
          </div>
          <div className="tw-text-base tw-font-bold tw-text-text-primary tw-mb-3">
            {state.title}
          </div>
          <pre
            className="tw-text-sm tw-text-text-primary"
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              width: "100%",
              boxSizing: "border-box",
              fontFamily: "inherit",
            }}
          >
            {state.message ?? "-"}
          </pre>
        </div>

        <Button
          className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-p-2 tw-mt-4 tw-h-9 tw-w-full tw-rounded-xl tw-border-0 tw-text-white bg-gradient"
          onClick={() => setPopup(true)}
        >
          <LuTrash2 size={14} /> Hapus Pesan
        </Button>
      </div>

      <PopupConfirm
        open={popup}
        title="Hapus Pesan Ini?"
        message="Data pesan akan dihapus secara permanen dan tidak bisa dikembalikan lagi"
        textConfirm="Ya, Hapus"
        textCancel="Batalkan"
        onConfirm={onRemoveInbox}
        onCancel={() => setPopup(false)}
      />
    </>
  );
};
